import { render, staticRenderFns } from "./Cessionnaires.vue?vue&type=template&id=194712e8"
import script from "./Cessionnaires.vue?vue&type=script&lang=js"
export * from "./Cessionnaires.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports